import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import { useForm } from "react-hook-form";
import APIS from "../../constant/EndPoint";
//@ts-ignore
import { FormLayout } from "@careinfo/layout";
import { createRiderValidationForm } from "../../utils/validationSchemas";
import TextField from "../Reusable/TextField";
import ComboboxInput from "../Reusable/ComboboxInput";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
const CreateRider = (props: any) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    setValue,
    getValues,
    clearErrors,
  } = useForm<any>({
    resolver: yupResolver(createRiderValidationForm),
  });
  const { handleCreate, isLoading } = props;
  return (
    <FormLayout
      handleSubmit={handleSubmit}
      handleFormSubmit={handleCreate}
      setError={setError}
      buttonLabel={"Create"}
      isLoading={isLoading}
    >
      <div className={tw`grid  md:grid-cols-2 gap-x-4 mx-4`}>
        <ComboboxInput
          url={APIS.USER}
          queryKey={"user"}
          register={register("user")}
          errors={errors?.user}
          name={"user"}
          label={"User"}
          setValue={setValue}
          props={{
            is_active: true,
          }}
          placeholder={"Search user"}
          getValues={getValues}
          clearErrors={clearErrors}
        />
        <ComboboxInput
          url={APIS.BRANCH}
          queryKey={"barnch"}
          register={register("branch")}
          errors={errors?.branch}
          name={"branch"}
          label={"Branch"}
          props={{
            is_active: true,
          }}
          setValue={setValue}
          placeholder={"Select Branch"}
          getValues={getValues}
          clearErrors={clearErrors}
        />
        <TextField
          label={"License Number"}
          register={register("license_number")}
          errors={errors?.license_number}
        />
        <TextField
          label={"Ctitizenship Number"}
          register={register("citizen_ship_number")}
          errors={errors?.citizen_ship_number}
        />
      </div>
    </FormLayout>
  );
};

export default CreateRider;
